export enum TourismCertificateType {
  TOURISM_BUSINESS = 'TourismBusiness',
  SIMPLE_ACCOMMODATION = 'SimpleAccommodation',
  PARTIAL_TOURISM_BUSINES = 'PartialTourismBusines',
  APPLICATION_DOCUMENT_NUMBER = 'ApplicationDocumentNumber',
  HOUSING_PERMIT = 'HousingPermit',
  BEACH_BUSINESS = 'BeachBusiness',
  TOURISM_INVESTMENT = 'TourismInvestment',
}
